import type { ChangeEvent } from "react";
import { useEffect, useRef } from "react";
import { t } from "@/i18n-js/instance";
import {
  MAXIMUM_FREE_TRIAL_DAYS,
  MINIMUM_FREE_TRIAL_DAYS_WHEN_ENABLED as MINIMUM_FREE_TRIAL_DAYS,
} from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/FormModal/PricingTab/constants";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Input } from "@circle-react-uikit/Input";
import { useBulkImportTrialPaywallSubscriptionFormContext } from "./BulkImportTrialPaywallSubscriptionFormProvider";
import { CustomFormItem } from "./CustomFormItem";

export const TrialDaysForm = () => {
  const { paywallId, paywallTrialDays, setPaywallTrialDays } =
    useBulkImportTrialPaywallSubscriptionFormContext();
  const isPaywallBlank = paywallId === "";
  const paywallIdOld = useRef(paywallId);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const trialDays = e.target.value === "" ? NaN : Number(e.target.value);

    if (isNaN(trialDays)) {
      setPaywallTrialDays("");
    } else {
      if (trialDays < MINIMUM_FREE_TRIAL_DAYS) {
        setPaywallTrialDays("1");
      } else if (trialDays > MAXIMUM_FREE_TRIAL_DAYS) {
        setPaywallTrialDays(MAXIMUM_FREE_TRIAL_DAYS.toString());
      } else {
        setPaywallTrialDays(trialDays.toString());
      }
    }
  };

  useEffect(() => {
    if (paywallIdOld.current !== paywallId) {
      setPaywallTrialDays("");
      paywallIdOld.current = paywallId;
    }
  }, [paywallId, setPaywallTrialDays]);

  return (
    <CustomFormItem
      label={t("create_paywall_subscription_modal.form.trial_days_toggle")}
    >
      <Input
        name="paywall[paywall_trial_days]"
        suffix={t("create_paywall_subscription_modal.form.trial_days_suffix")}
        disabled={isPaywallBlank}
        otherClassName={classNames("", {
          "!opacity-100 !bg-secondary": isPaywallBlank,
        })}
        value={paywallTrialDays}
        onChange={onChange}
      />
    </CustomFormItem>
  );
};
